function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28 3.4375C14.7119 3.4375 3.9375 14.2119 3.9375 27.5C3.9375 40.7881 14.7119 51.5625 28 51.5625C41.2881 51.5625 52.0625 40.7881 52.0625 27.5C52.0625 14.2119 41.2881 3.4375 28 3.4375ZM23.7031 35.6641C23.7031 35.9004 23.5098 36.0938 23.2734 36.0938H20.6953C20.459 36.0938 20.2656 35.9004 20.2656 35.6641V19.3359C20.2656 19.0996 20.459 18.9062 20.6953 18.9062H23.2734C23.5098 18.9062 23.7031 19.0996 23.7031 19.3359V35.6641ZM35.7344 35.6641C35.7344 35.9004 35.541 36.0938 35.3047 36.0938H32.7266C32.4902 36.0938 32.2969 35.9004 32.2969 35.6641V19.3359C32.2969 19.0996 32.4902 18.9062 32.7266 18.9062H35.3047C35.541 18.9062 35.7344 19.0996 35.7344 19.3359V35.6641Z",
  fill: "#262626"
});

var SvgPauseCircle = function SvgPauseCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPauseCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause-circle.bbe0775b.svg";
export { ForwardRef as ReactComponent };